<template>
  <div>
    <b-card>
      <div class="d-flex align-items-center justify-content-end">
        <b-button
          variant="success"
          @click="onAddClicked"
          v-can="{ slug: $route.meta.slug, action: 'C' }"
        >
          <feather-icon icon="PlusIcon" class="mr-50" />
          إضافة
        </b-button>
      </div>
      <hr />
      <b-row>
        <b-col cols="12" lg="6" xl="4" md="12">
          <search-input placeholder="البحث بحسب الأسم" v-model="nameFilter" />
        </b-col>
      </b-row>
      <data-table
        ref="membersTable"
        ep="v2/general-authority-members"
        :fields="fields"
        v-can="{ slug: $route.meta.slug, action: 'S' }"
      >
        <template #cell(gender)="{ value }">
          {{ value ? "ذكر" : "أنثى" }}
        </template>
        <template #cell(dob)="{ value }">
          {{ $moment(value).format("YYYY-MM-DD") }}
        </template>
        <template #cell(can_vote)="{ value }">
          {{ value ? "نعم" : "لا" }}
        </template>
        <template #cell(active)="{ value }">
          {{ value ? "نعم" : "لا" }}
        </template>
        <template #cell(actions)="row">
          <div class="d-flex justify-content-between align-items-center">
            
            <div>
              <b-badge
                v-if='row.item.old_ngo_id'
                pill
                variant="light-primary"
              >
                منقول من المنظمة المندمجة
              </b-badge>
            </div>
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-can="{ slug: $route.meta.slug, action: 'U' }"
                @click="onUpdateClicked(row.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">تعديل</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-can="{ slug: $route.meta.slug, action: 'D' }"
                @click="onDelete(row.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">حذف</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
      </data-table>
      <form-modal
        ref="memberModal"
        :formSchema="membersFormSchema"
        title="معلومات العضو"
        v-model="formModal"
        :loading="loading"
        @confirm="onModalConfirmed"
        static
      >
        <template #can_vote="{ form }">
          <b-form-group label="فعال">
            <b-form-radio-group :options="radioOptions" v-model="form.can_vote">
            </b-form-radio-group>
          </b-form-group>
        </template>
        <template #active="{ form }">
          <b-form-group label="يحق له التصويت">
            <b-form-radio-group :options="radioOptions" v-model="form.active">
            </b-form-radio-group>
          </b-form-group> </template
      ></form-modal>
    </b-card>
  </div>
</template>

<script>
import dataTable from "@/components/data-table";
import {
  BButton,
  BRow,
  BCol,
  BCard,
  BBadge,
  BDropdown,
  BDropdownItem,
  BFormRadioGroup,
  BFormGroup,
  
} from "bootstrap-vue";
import FormModal from "@/components/FormModal.vue";
import { mapActions, mapGetters } from "vuex";
import debounce from "lodash.debounce";
import SearchInput from "@/components/SearchInput.vue";
export default {
  components: {
    dataTable,
    BDropdown,
    BDropdownItem,
    BButton,
    BRow,
    BCol,
    BCard,
    BBadge,
    FormModal,
    SearchInput,
    BFormRadioGroup,
    BFormGroup,
  },
  methods: {
    ...mapActions("AdministrativeStatus/GeneralAuthority", [
      "addMember",
      "updateMember",
      "deleteMember",
    ]),
    onUpdateClicked(form) {
      var toUpdate = {
        id: form.id,
        full_name: form.full_name,
        id_number: form.id_number,
        phone_number: form.phone_number,
        gender: form.gender,
        dob: form.dob,
        active: form.active,
        can_vote: form.can_vote,
      };
      this.$refs.memberModal.init(toUpdate);
      this.formModal = true;
    },
    onAddClicked() {
      this.$refs.memberModal.init({
        active: true,
        can_vote: true,
      });
      this.formModal = true;
    },
    onDelete(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف العضو؟", {
          title: "تأكيد حذف العضو",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value)
            this.deleteMember(id).then(() => {
              this.$refs.membersTable.refreshTable();
            });
        });
    },

    async onModalConfirmed(form) {
      if (form.id)
        await this.updateMember(form).then(() => {
          this.$refs.membersTable.refreshTable();
        });
      else
        await this.addMember(form).then(() => {
          this.$refs.membersTable.refreshTable();
        });

      this.formModal = false;
    },
  },
  data() {
    return {
      formModal: false,
      nameFilter: "",
      radioOptions: [
        {
          text: "نعم",
          value: true,
        },
        {
          text: "لا",
          value: false,
        },
      ],
      membersFormSchema: {
        full_name: {
          component: "FormInput",
          key: "full_name",
          attrs: {
            label: "الاسم الكامل",
            rules: "required",
          },
        },
        id_number: {
          component: "FormCleave",
          key: "id_number",
          attrs: {
            rules: "required",
            label: "الرقم الوطني",
            isNumber: true,
            charsCount: 11,
          },
        },
        dob: {
          component: "FormMask",
          key: "dob",
          attrs: {
            label: "تاريخ الميلاد",
            options: "date",
            rules: "required",
            placeholder: "YYYY-MM-DD",
          },
        },
        gender: {
          component: "FormSelect",
          key: "gender",
          attrs: {
            id: "job_title",
            label: "الجنس",
            rules: "required",
            options: [
              { title: "ذكر", value: true },
              { title: "أنثى", value: false },
            ],
            reduce: (x) => x.value,
            getOptionLabel: (x) => x.title,
          },
        },
        phone_number: {
          component: "FormCleave",
          key: "phone_number",
          attrs: {
            label: " رقم الموبايل",
            isNumber: true,
            charsCount: 10,
          },
        },
        affiliation_date: {
          component: "FormMask",
          key: "affiliation_date",
          attrs: {
            label: "تاريخ الانتساب",
            options: "date",
            rules: "required",
            placeholder: "YYYY-MM-DD",
          },
        },
        can_vote: {
          key: "can_vote",
        },
        active: {
          key: "active",
        },
      },

      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        { key: "full_name", label: "الاسم" },
        {
          key: "id_number",
          label: "الرقم الوطني",
        },
        { key: "gender", label: "الجنس" },
        {
          key: "dob",
          label: "تاريخ الميلاد",
        },
        {
          key: "phone_number",
          label: "رقم الموبايل",
        },
        {
          key: "affiliation_date",
          label: "تاريخ الانتساب",
        },
        {
          key: "active",
          label: "فعال",
        },
        {
          key: "can_vote",
          label: "يحق له التصويت",
        },

        { key: "actions", label: " " },
      ],
    };
  },
  watch: {
    nameFilter: debounce(function (val) {
      this.$refs.membersTable.setQueryParams({ search: val });
      this.$refs.membersTable.refreshTable();
    }, 500),
  },
  computed: {
    ...mapGetters("AdministrativeStatus/GeneralAuthority", ["loading"]),
  },
};
</script>
